/**
 * Gabarits HTML sûrs par défaut.
 *
 * La version précédente appelait une fonction `esc()` à la main sur chaque
 * valeur insérée. Ça marche jusqu'au jour où on l'oublie une fois, sur un nom
 * de commune venu d'une API. Ici l'échappement est le comportement par
 * défaut : il faut demander explicitement `raw()` pour y échapper.
 *
 * Un gabarit imbriqué se compose naturellement, et un tableau se concatène,
 * ce qui couvre les deux besoins réels de l'interface.
 */

/** Du HTML déjà sûr, qui ne doit pas être échappé une seconde fois. */
export class Html {
  constructor(readonly value: string) {}
  toString(): string {
    return this.value;
  }
}

export function escapeHtml(value: unknown): string {
  return String(value).replace(
    /[&<>"']/g,
    (char) =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char] ?? char,
  );
}

function stringify(value: unknown): string {
  if (value instanceof Html) return value.value;
  if (Array.isArray(value)) return value.map(stringify).join('');
  // null, undefined et false ne rendent rien : pratique pour les conditions.
  if (value === null || value === undefined || value === false) return '';
  return escapeHtml(value);
}

export function html(strings: TemplateStringsArray, ...values: unknown[]): Html {
  let out = strings[0] ?? '';
  for (let i = 0; i < values.length; i += 1) {
    out += stringify(values[i]) + (strings[i + 1] ?? '');
  }
  return new Html(out);
}

/** À n'utiliser que sur du HTML dont on est l'auteur. */
export function raw(value: string): Html {
  return new Html(value);
}

/** Remplace le contenu d'un élément par un gabarit. */
export function render(target: Element, template: Html): void {
  target.innerHTML = template.value;
}
